export interface ChartNode {
  id: string;

  // Scaled coordinates:
  x: number;
  y: number;

  radius: number;

  label: string;
  color: string;
  contributingInfo:
    { isAmongLargest: false } |
    { isAmongLargest: true, index: number };
}

export enum LineStyle {
  ShortDash,
  LongDash,
  Solid,
}
export interface ChartLine {
  id: string;
  x0: number;
  y0: number;
  x1: number;
  y1: number;
  style: LineStyle;
  thickness: number;
}
